var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "space-y-6 mb-12 text-center" }, [
        _c("h1", { staticClass: "text-theme text-xl" }, [
          _vm._v(_vm._s(_vm.defaultVariant.title)),
        ]),
        _vm._v(" "),
        _vm.defaultVariant.product.text
          ? _c("p", {
              staticClass: "max-w-sm mx-auto text-theme",
              domProps: {
                innerHTML: _vm._s(_vm.nl2br(_vm.defaultVariant.product.text)),
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex items-center justify-center mb-7" },
        [
          _c(
            "label",
            {
              staticClass:
                "text-xxs text-theme font-semibold uppercase mr-4 mt-1",
            },
            [_vm._v("qty")]
          ),
          _vm._v(" "),
          _c("SelectMenu", {
            attrs: { options: _vm.quantityOptions, value: _vm.qty, themed: "" },
            model: {
              value: _vm.qty,
              callback: function ($$v) {
                _vm.qty = _vm._n($$v)
              },
              expression: "qty",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("ProductAddToCartForm", {
        staticClass: "btn-strong--alt",
        attrs: {
          variant: _vm.defaultVariant,
          quantity: _vm.qty,
          loading: false,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }